<template>
    <div class="prizes-root">
        <div class="inner-section" v-if="showPrizes">
            <div class="top-bar">
                <span><img class="back-btn" :src="_global.isMobile 
                           ? _global.assetsRoot + '/prize/mobile/btn_back.png' 
                           : _global.assetsRoot + '/prize/desktop/btn_back.png'" alt="return-icon" @click="$emit('back')"/></span>
            </div>
            <!--div class="live-claw-title">
                <img class="prize-title-image" :src="_global.isMobile 
                ? _global.assetsRoot + '/prize/mobile/title_' + [_i18n.locale] + '.png' 
                : _global.assetsRoot + '/prize/desktop/title_' + [_i18n.locale] + '.png'" alt="" />
            </div-->

            <div class="prize-section">
                <section class="info-section">
                    <div>
                        <img class="prize-frame-image" :src="_global.isMobile 
                        ? _global.assetsRoot + '/prize/mobile/bg_frame.png' 
                        : _global.assetsRoot + '/prize/desktop/bg_frame.png'" alt="" />
                    </div>
                    <div class="how-it-works">
                        <div class="header-section">
                            {{ $t('message.prizeHowToPlay') }}
                        </div>
                        <div class="grid-section">
                            <div>
                                <img :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/ic_pick_a_prize.png' 
                                : _global.assetsRoot + '/prize/desktop/ic_pick_a_prize.png'" alt="" />
                                <div class="red-point">
                                    <img :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/red_point.png' 
                                : _global.assetsRoot + '/prize/desktop/red_point.png'" alt="" />
                                    <span>1</span>
                                    <span>{{ $t('message.prizePick') }}</span>
                                </div>
                            </div>
                            <div>
                                <img :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/ic_tokens.png' 
                                : _global.assetsRoot + '/prize/desktop/ic_tokens.png'" alt="" />
                                <div class="red-point">
                                    <img :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/red_point.png' 
                                : _global.assetsRoot + '/prize/desktop/red_point.png'" alt="" />
                                    <span>2</span>
                                    <span>{{ $t('message.prizeToken') }}</span>
                                </div>
                            </div>
                            <div>
                                <img :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/ic_live_claw.png' 
                                : _global.assetsRoot + '/prize/desktop/ic_live_claw.png'" alt="" />
                                <div class="red-point">
                                    <img :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/red_point.png' 
                                : _global.assetsRoot + '/prize/desktop/red_point.png'" alt="" />
                                    <span>3</span>
                                    <span>{{ $t('message.prizeClaw') }}</span>
                                </div>
                            </div>
                            <div>
                                <img :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/ic_win_rewards.png' 
                                : _global.assetsRoot + '/prize/desktop/ic_win_rewards.png'" alt="" />
                                <div class="red-point">
                                    <img :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/red_point.png' 
                                : _global.assetsRoot + '/prize/desktop/red_point.png'" alt="" />
                                    <span>4</span>
                                    <span>{{ $t('message.prizeWin') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="choose-prize">
                        <div class="header-section">
                            <img class="arrow-icon" :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/ic_arrow.png' 
                                : _global.assetsRoot + '/prize/desktop/ic_arrow.png'" alt="" />
                            <span>{{ $t('message.prizeChoose') }}</span>
                            <img class="arrow-icon right" :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/ic_arrow.png' 
                                : _global.assetsRoot + '/prize/desktop/ic_arrow.png'" alt="" />
                        </div>
                        <div class="grid-section">
                            <article class="prize-card" v-for="(item, index) in prizeCards" :key="item.product_id || index">
                                <img class="prize-card-bg" :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/prize_bg.png' 
                                : _global.assetsRoot + '/prize/desktop/prize_bg.png'" alt="" />
                                <div class="content-section">
                                    <div class="card-top-row">
                                        <span class="prize-name">{{ getTitle(item) }}</span>
                                        <button class="info-button" type="button" @click="openPopup(item)">
                                            <img :src="_global.isMobile 
                                                ? _global.assetsRoot + '/prize/mobile/btn_info.png' 
                                                : _global.assetsRoot + '/prize/desktop/btn_info.png'" alt="Info" />
                                        </button>
                                    </div>
                                    <div class="card-coin-row">
                                        <img :src="_global.isMobile 
                                                ? _global.assetsRoot + '/prize/mobile/ic_coin.png' 
                                                : _global.assetsRoot + '/prize/desktop/ic_coin.png'" alt="" />
                                        <span>{{ coins(item.reward_coins || 5000) }}</span>
                                    </div>
                                    <div class="card-prize-image-wrap">
                                        <img :src="_global.isMobile 
                                                ? _global.assetsRoot + '/prize/mobile/ic_golden_prize_0' + (index + 1) + '.png' 
                                                : _global.assetsRoot + '/prize/desktop/ic_golden_prize_0' + (index + 1) + '.png'" class="card-prize-image" alt="" />
                                    </div>
                                    <button class="play-now-button" type="button" @click="getGameUrl(item)">
                                        <img class="play-now-bg card-prize-image" :src="_global.isMobile 
                                                ? _global.assetsRoot + '/prize/mobile/btn_play_now.png' 
                                                : _global.assetsRoot + '/prize/desktop/btn_play_now.png'" alt="" />
                                        <div class="play-now-content">
                                            <div>{{ $t('message.prizeListTitle') }}</div>
                                            <div>
                                                <img :src="_global.isMobile 
                                                ? _global.assetsRoot + '/prize/mobile/ic_lucky_coin.png' 
                                                : _global.assetsRoot + '/prize/desktop/ic_lucky_coin.png'" class="card-prize-image" alt="" />
                                                {{ item.cost || 98 }}
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            </article>
                        </div>
                    </div>
                </section>            
            </div>
            <section class="features">
                <div class="header-section">
                    {{ $t('message.prizeFeature') }}
                </div>
                <div class="grid-section">
                    <div>
                        <img :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/ic_video.png' 
                                : _global.assetsRoot + '/prize/desktop/ic_video.png'" class="card-prize-image"  alt="" />
                        <div>{{ $t('message.prizeLiveGame') }}</div>
                    </div>
                    <div>
                        <img :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/ic_real_time_control.png' 
                                : _global.assetsRoot + '/prize/desktop/ic_real_time_control.png'" alt="" />
                        <div>{{ $t('message.prizeRealTime') }}</div>
                    </div>
                    <div>
                        <img :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/ic_balanced.png' 
                                : _global.assetsRoot + '/prize/desktop/ic_balanced.png'" alt="" />
                        <div>{{ $t('message.prizeBalance') }}</div>
                    </div>
                    <div>
                        <img :src="_global.isMobile 
                                ? _global.assetsRoot + '/prize/mobile/ic_web_store.png' 
                                : _global.assetsRoot + '/prize/desktop/ic_web_store.png'" alt="" />
                        <div>{{ $t('message.prizeWebstore') }}</div>
                    </div>
                </div>

                <!-- POPUP -->
                <div v-if="showPopup" class="popup-overlay">
                    <div v-if="isLoading" class="popup-loading-mask"></div>
                    <div class="popup-box">
                        <!-- CLOSE -->
                        <img class="close-btn" :src="_global.isMobile 
                            ? _global.assetsRoot + '/choose_your_prize/mobile/btn_close.png' 
                            : _global.assetsRoot + '/choose_your_prize/desktop/btn_close.png'" alt=""
                            @click="closePopup" />

                        <!-- PRODUCT -->
                        <div class="popup-image-box">
                            <img class="popup-image" :src="selectedProduct.product_image" alt="" />
                            <span v-if="isLoading" class="loader-icon" aria-label="Loading">
                                <img class="loader-image" :src="_global.isMobile 
                            ? _global.assetsRoot + '/choose_your_prize/mobile/ic_loading.png' 
                            : _global.assetsRoot + '/choose_your_prize/desktop/ic_loading.png'" alt="" />
                            </span>

                            <div class="ic-coins-popup">
                                <img class="loader-image" :src="_global.isMobile 
                            ? _global.assetsRoot + '/choose_your_prize/mobile/ic_coins.png' 
                            : _global.assetsRoot + '/choose_your_prize/desktop/ic_coins.png'" alt="" />
                                <span>{{ coins(selectedProduct.reward_coins) }}</span>
                            </div>
                        </div>

                        <!-- TITLE -->
                        <div class="popup-title">
                            {{ getTitle(selectedProduct) }}
                        </div>

                        <!-- SUBTITLE -->
                        <div class="popup-subtitle">
                            {{ getDescription(selectedProduct) }}
                        </div>

                        <!-- BUTTON -->
                        <button class="go-btn" @click="getGameUrl(selectedProduct)" :disabled="isLoading" :class="{ 'is-loading': isLoading }">
                            <img class="btn-bg" :src="_global.isMobile 
                            ? _global.assetsRoot + '/choose_your_prize/mobile/btn_go.png' 
                            : _global.assetsRoot + '/choose_your_prize/desktop/btn_go.png'" alt="" />
                            <span class="go-text">{{ $t('message.goButtonText') }}</span>
                        </button>

                    </div>
                </div>
            </section>
        </div>

        <section v-if="showIframe" class="iframe-container">
            <div class="iframe-top-bar" :style="{ height: iframeTopMargin + 'px' }">
                <img class="iframe-close-icon" :src="_global.isMobile 
                               ? _global.assetsRoot + '/choose_your_prize/mobile/Drclaw_btn_return.png' 
                               : _global.assetsRoot + '/choose_your_prize/desktop/Drclaw_btn_return.png'" alt="Close" @click="closeIframe" />
            </div>
            <iframe
                class="game-iframe"
                :src="gameUrl"
                :style="{ top: iframeTopMargin + 'px', height: iframeHeight + 'px' }"
            ></iframe>
        </section>
    </div>
</template>

<script>
import api from '../../network/api.js';
import utils from '../../utils/utils.js';

export default {
    props: {
        data: Array
    },
    computed: {
        prizeCards() {
            if (this.data && this.data.length) {
                return this.data.slice(0, 3);
            }

            return [
                /*{ product_id: 'placeholder-1', cost: 98, reward_coins: 5000 },
                { product_id: 'placeholder-2', cost: 98, reward_coins: 5000 },
                { product_id: 'placeholder-3', cost: 98, reward_coins: 5000 }*/
            ];
        }
    },
    data() {
        return {
            showPopup: false,
            showIframe: false,
            showPrizes: true,
            selectedProduct: {},
            gameUrl: "",
            iframeTopMargin: 55,
            iframeHeight: Math.max(window.innerHeight - 55, 0),
            isLoading: false,
            isLandscape: window.innerWidth > window.innerHeight
        };
    },

    mounted() {
        // Update iframe height on window resize
        /*window.addEventListener('resize', this.updateIframeHeight);
        this.updateIframeHeight(); // Set initial height*/

        this.updateIframeHeight();
        window.addEventListener('resize', this.updateIframeHeight);

        // iPhone Safari fix
        if (window.visualViewport) {
            window.visualViewport.addEventListener(
                'resize',
                this.updateIframeHeight
            );
        }
    },

    beforeDestroy() {
        // Remove event listener when component is destroyed
        window.removeEventListener('resize', this.updateIframeHeight);

        if (window.visualViewport) {
            window.visualViewport.removeEventListener(
                'resize',
                this.updateIframeHeight
            );
        }
    },

    methods: {
        openPopup(item) {
            this.selectedProduct = item;
            this.showPopup = true;
            this.isLoading = false;
        },

        closePopup() {
            this.showPopup = false;
            this.isLoading = false;
        },

        updateIframeHeight() {
            //this.iframeHeight = window.innerHeight; // Update iframe height dynamically

            this.$nextTick(() => {
                const viewportHeight = window.visualViewport
                    ? window.visualViewport.height
                    : window.innerHeight;
                this.iframeHeight = Math.max(viewportHeight - this.iframeTopMargin, 0);
            });
        },

        updateBalance(){
            api.guestLogin(this._global.sid, this._global.user.userID).then((resp) => {
                if (resp.data.status === "ok") {
                    //console.log("I am called");
                    this.$emit('updateCoins', resp.data.golden_token, resp.data.coins, resp.data.chips); // Correct event emission
                    //this.$emit('updateCoins', 200, 300, 400);
                }
            });
        },

        getGameUrl(selectedProduct) {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;
            this.selectedProduct = selectedProduct;

            // Start polling the API every 30 seconds
            if (!this.pollingInterval) {
                this.pollingInterval = setInterval(() => {
                    this.updateBalance();
                }, 20000); // 20 seconds
            }

            // Initial API call
            api.getClawGameUrl(this._global.sid)
                .then((resp) => {
                    if (resp.data.status === "ok") {
                        this.gameUrl = `${resp.data.game_url}&payload_data=${encodeURIComponent(JSON.stringify({ product_id: selectedProduct.product_id }))}`;
                        this.showPopup = false;
                        this.showIframe = true;
                        this.showPrizes = false;
                        this.$emit('showFooter', true);
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        closeIframe() {
            this.updateBalance();
            this.showIframe = false;
            this.showPrizes = true;
            this.$emit('showFooter', false);

            // Stop polling the API
            if (this.pollingInterval) {
                clearInterval(this.pollingInterval);
                this.pollingInterval = null;
            }
        },

        getTitleImage() {
            let userLanguage = this._global.user.lang;

            switch(userLanguage){
                case 'pt':
                    return this._global.assetsRoot + '/choose_your_prize/mobile/title_pt.png';
                    break;
                default:
                    return this._global.assetsRoot + '/choose_your_prize/mobile/title_en.png';
                    break
            }
        },

        getTitle(item) {
            let userLanguage = this._global.user.lang;

            switch(userLanguage){
                case 'pt':
                    return item.product_name.pt;
                    break;
                default:
                    return item.product_name.en;
                    break
            }
        },

        getDescription(item) {
            let userLanguage = this._global.user.lang;

            switch(userLanguage){
                case 'pt':
                    return item.product_desc.pt;
                    break;
                default:
                    return item.product_desc.en;
                    break
            }
        },

        coins(value) { return utils.fc(value) || 0 }
    }
};
</script>

<style lang="scss">
@import "../../assets/css/variables.scss";
@import url('https://fonts.googleapis.com/css2?family=Luckiest+Guy&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bowlby+One+SC&display=swap');

.prize-bg-image {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 0;
}

.prizes-root {
    background: url($assetRoot + "/prize/desktop/PC_bg.png") center top no-repeat;
    background-size: cover; /* maintain aspect ratio */
    overflow: hidden;
    position:relative;

    overflow-y:auto;
    overflow-x:hidden;
}

.inner-section{
    position:relative;

    width:100%;

    min-height:calc(100vw * 1532 / 1920);
}

.live-claw-title {
    position: absolute;
    top: 13%;
    left: 42%;
}

.prize-title-image {
    width: 70%;
    position: relative;
    z-index: 1;
}

.prize-frame-image{
    width: 100%;
    position: relative;
    z-index: 1;
    height: 110%;
}

.prize-section {
    position: absolute;
    top: 42%;
    width: 50%;
    height: 45%;
    left: 25%;
}

.info-section {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
}

.info-section .how-it-works img {
    width: 100%;
    height: auto;
}

.info-section .how-it-works .header-section{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-family: "Bowlby One SC", sans-serif;
    color: #ffffff; 
    font-size: clamp(12px, 3.6vw, 44px);
    text-transform: uppercase;
    -webkit-text-stroke: 6px #183cd0;
    paint-order: stroke fill;
}

.info-section .how-it-works .grid-section {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    align-items: start;
    column-gap: 4.2vw;
    padding-left: 3.5%;
    padding-right: 3.5%;

    > div {
        position: relative;
        display: flex;
        flex-direction: column;
    }

    > div > img {
        width: 100%;
        height: auto;
    }

    .red-point{
        position: relative;
        display: flex;
        align-items: center;
        gap: 5px;
        width: auto;
        margin-top: 4%;

        img {
            display: block;
            width: 24px;
            height: auto;
        }

        span:first-of-type {
            position: absolute;
            left: 12px;
            top: 50%;
            transform: translate(-50%, -50%);
            font-family: "Arial Rounded MT Bold", "Arial Rounded MT", Arial, sans-serif;
            font-style: normal;
            font-weight: 700;
            font-size: 15px;
            line-height: 1;
            color: #ffffff;
        }

        span:last-of-type {
            position: static;
            transform: none;
            font-family: "Arial Rounded MT Bold", "Arial Rounded MT", Arial, sans-serif;
            font-style: normal;
            font-weight: 700;
            font-size: clamp(10px, 1.4vw, 20px);
            line-height: 0.95;
            letter-spacing: 0.1px;
            color: #39205b;
            max-width: calc(100% - 26px);
        }
    }
}

.choose-prize {
    position: relative;
    left: 0;
    right: 0;
    top: 5%;
    padding: 0 1.5vw;
}

.choose-prize .header-section {
    display: grid;
    grid-template-columns: 26px 1fr 26px;
    align-items: center;
    column-gap: 8px;
    width: calc(100% - 8px);
    line-height: 1;
    text-transform: uppercase;
    font-family: "Bowlby One SC", sans-serif;
    color: #ffffff; 
    font-size: clamp(18px, 3.6vw, 44px);
    -webkit-text-stroke: 6px #183cd0;
    paint-order: stroke fill;
}

.choose-prize .header-section span {
    text-align: center;
}

.choose-prize .arrow-icon {
    width: 100%;
    height: auto;
}

.choose-prize .arrow-icon.right {
    transform: scaleX(-1);
}

.info-section .choose-prize .grid-section {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 2.2vw;
}

.prize-card {
    position: relative;
}

.prize-card-bg {
    width: 100%;
    display: block;
}

.choose-prize .content-section {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    padding: 8% 9% 10%;
}

.card-top-row,
.card-coin-row {
    display: flex;
    align-items: center;
}

.card-top-row {
    justify-content: space-between;
}

.prize-name {
    flex: 1;
    text-align: center;
    font-family: Arial, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
    color: #39205b;
}

.info-button {
    padding: 0;
    border: 0;
    background: transparent;
    line-height: 0;
}

.info-button img {
    width: 18px;
    height: auto;
}

.card-coin-row {
    justify-content: center;
    gap: 4px;
    margin-top: 4px;
}

.card-coin-row img {
    width: 15%;
    height: auto;
}

.card-coin-row span {
    font-family: Arial, sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #fec330;
    -webkit-text-stroke: 3px #a65103;
    paint-order: stroke fill;
    line-height: 1;
}

.card-prize-image-wrap {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 0;
    padding: 4px 0;
}

.card-prize-image {
    max-height: 100%;
    object-fit: contain;
}

.play-now-button {
    position: relative;
    padding: 0;
    border: 0;
    background: transparent;
    line-height: 0;
}

.play-now-bg {
    width: 100%;
    display: block;
}

.play-now-content {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    /*justify-content: space-evenly;*/
    gap: 3px;
    padding: 0 4px;
    color: #fff;
    font-size: 11px;
    line-height: 1;
}

.play-now-content div:first-child {
    max-width: 34px;
    text-align: center;
    font-family: "Arial Black", "Arial Bold", Arial, sans-serif;
    font-size: 12px;
    font-weight: 900;
    color: #ffffff;
    -webkit-text-stroke: 2px #056b0d;
    paint-order: stroke fill;
    margin-left: 15%;
}

.play-now-content div:last-child {
    font-family: Arial, sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
    -webkit-text-stroke: 2px #056b0d;
    paint-order: stroke fill;
    line-height: 1;
    display: flex;
    margin-left: 25%;
    flex-direction: row;
}

.play-now-content .card-prize-image {
    width: 35%;
    height: auto;
}

.features {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0.6vh 1.8vw 1.2vh;
    /*background: linear-gradient(180deg, rgba(255, 243, 150, 0.7) 0%, rgba(255, 239, 115, 0.95) 45%, #f7ea6f 100%);*/
}

.features .header-section {
    text-align: center;
    line-height: 1;
    text-transform: uppercase;
    font-family: "Bowlby One SC", sans-serif;
    color: #ffffff; 
    font-size: clamp(18px, 3.6vw, 44px);
    -webkit-text-stroke: 6px #183cd0;
    paint-order: stroke fill;
}

.features .grid-section {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    align-items: start;
    gap: 2.2vw;
}

.features .grid-section > div {
    text-align: center;
}

.features .grid-section img {
    width: 28px;
    height: 28px;
    object-fit: contain;
}

.features .grid-section > div > div {
    margin-top: 4px;
    font-family: "Arial Rounded MT Bold", "Arial Rounded MT", Arial, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 1.05;
    color: #39205b;
    text-transform: uppercase;
}

.info-section {
    .how-it-works{
        z-index: 2;
        .header-section{
            font-size: clamp(10px, 1.5vw, 40px);
            top: 1%;
        }

        .grid-section{
            top: 10%;
            position: absolute;

            .red-point {
                height: 35px;

                img {
                    width: 15%;
                }

                span:first-of-type{
                    left: 7%;
                    font-size: clamp(10px, 1.2vw, 15px);
                }

                span:last-of-type {
                    font-size: clamp(8px, 1vw, 15px);
                    line-height: 0.95;
                    vertical-align: middle;
                }
            }

            /*div{
                img{
                    width: 75%;
                    height: auto;
                }
            }*/
        }
    }

    .choose-prize {
        top: 48%;
        padding: 0 1vw;
        position: absolute;
        z-index: 2;

        .header-section {
            font-size: clamp(10px, 1.5vw, 44px);
        }

        .grid-section {
            gap: 1.6vw;
            margin-top: 2%;
        }
    }

    /*.prize-card-bg{
        transform: scaleY(.8);
    }*/
}

/*.features {
    padding: 1%;
    top: 85%;
    width: 50%;
    left: 25%;
    background: unset;
}*/

.features .header-section {
    font-size: clamp(10px, 1.5vw, 44px);
}

.features .grid-section {
    gap: 1.4vw;
    width: 60%;
    margin-left: 20%;
}

.features .grid-section img {
    width: 50%;
}

.features .grid-section>div>div{
    font-size: clamp(10px, 1vw, 44px);
}

.back-btn{
    position: absolute;
    left: 15%;
    top: 2%;
}


/* =========================
   POPUP
========================= */

.popup-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.72);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    backdrop-filter: blur(2px);
}

.popup-box {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: popupShow 0.25s ease;
}

.popup-loading-mask {
    position: absolute;
    inset: -10px;
    background: rgba(0, 0, 0, 0.28);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    border-radius: 24px;
    z-index: 6;
    pointer-events: none;
}

/* CLOSE */
.close-btn {
    position: absolute;
    cursor: pointer;
    z-index: 5;
    right: 16px;
}

/* IMAGE BOX */
.popup-image-box {
    position: relative;
    height: clamp(250px, 30vw, 600px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.popup-image {
    max-width: 100%;
    max-height: 90%;
    object-fit: contain;
}

.loader-icon {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    z-index: 10;

    .loader-image {
        width: 72px;
        display: block;
        animation: loaderSpin 1s linear infinite;
        transform-origin: center center;
    }
}

/* TITLE */
.popup-title {
    font-family: "Luckiest Guy", cursive;
    font-size: clamp(28px, 4vw, 65px);
    color: #ffbe18;
    text-align: center;
    line-height: 1.1;
    word-break: break-word;
    text-shadow:
        -4px -4px 0 #b72e02,
        0px -4px 0 #b72e02,
        4px -4px 0 #b72e02,
        -4px  0px 0 #b72e02,
        4px  0px 0 #b72e02,
        -4px  4px 0 #b72e02,
        0px  4px 0 #b72e02,
        4px  4px 0 #b72e02;
}

/* SUBTITLE */
.popup-subtitle {
    font-family: "Luckiest Guy", cursive;
    text-align: center;
    line-height: 1.2;
    max-width: 90%;
    font-size: clamp(24px, 3.5vw, 55px);
    color: #ffffff;
    text-shadow:
        -4px -4px 0 #b72e02,
        0px -4px 0 #b72e02,
        4px -4px 0 #b72e02,
        -4px  0px 0 #b72e02,
        4px  0px 0 #b72e02,
        -4px  4px 0 #b72e02,
        0px  4px 0 #b72e02,
        4px  4px 0 #b72e02;
}

/* GO BUTTON */
.go-btn {
    box-shadow: 0px 4px 20px #035986;
    border-radius: 20px;
    position: relative;
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: 0.2s ease;

    &:disabled {
        cursor: not-allowed;
    }

    &.is-loading {
        filter: saturate(0.8);
    }

    .btn-bg {
        width: 260px;
        display: block;
    }

    .go-text {
        font-family: "Luckiest Guy", cursive;
        position: absolute;
        color: #ffffff;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        white-space: nowrap;

        font-size: clamp(20px, 3vw, 60px);
    }

}

/* ANIMATION */
@keyframes popupShow {
    from {
        opacity: 0;
        transform: scale(0.85);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes loaderSpin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.iframe-container {
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #000;
}

.iframe-top-bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #000;
    display: flex;
    align-items: center;
    z-index: 12;
}

.game-iframe {
    position: absolute;
    left: 0;
    width: 100%;
    border: 0;
    display: block;
}

.iframe-close-icon {
    position: relative;
    margin: 10px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    z-index: 10; /* Ensure it appears above the iframe */
}

.ic-coins{
    position: absolute;
    top: 2%;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    img{
        position: static;
        transform: none;
        width: 40px;
        height: 40px;
    }

    span{
        display: inline-block;
        width: auto;
        font-family: "Arial";
        font-weight: bold;
        margin-left: 0;
        text-align: center;
        line-height: 1.2;
        font-size: clamp(35px, 2vw, 55px);
        color: #fcfc7b;
        text-shadow:
            -2px -2px 0 #a65103,
            0px -2px 0 #a65103,
            2px -2px 0 #a65103,
            -2px  0px 0 #a65103,
            2px  0px 0 #a65103,
            -2px  2px 0 #a65103,
            0px  2px 0 #a65103,
            2px  2px 0 #a65103;
    }
}

.ic-coins-popup{
    position: absolute;
    top: clamp(20px, 3vw, 100px);
    left: 0;
    width: 100%;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    img{
        position: static;
        transform: none;
        width: 40px;
        height: 40px;
    }

    span{
        display: inline-block;
        width: auto;
        font-family: "Arial";
        font-weight: bold;
        margin-left: 0;
        text-align: center;
        line-height: 1.2;
        font-size: clamp(35px, 2vw, 55px);
        color: #fcfc7b;
        text-shadow:
            -2px -2px 0 #a65103,
            0px -2px 0 #a65103,
            2px -2px 0 #a65103,
            -2px  0px 0 #a65103,
            2px  0px 0 #a65103,
            -2px  2px 0 #a65103,
            0px  2px 0 #a65103,
            2px  2px 0 #a65103;
    }
}

.mobile{
    .inner-section{
        min-height: calc(150vh * 1920 / 1532);
    }

    .prize-section{
        height: 25%;
    }

    .prize-frame-image{
        height: 85%;
    }

    .feature{
        padding: unset;
    }

    .features .grid-section img {
        width: 35%;
    }

    .features .grid-section>div>div{
        margin: unset;
    }

    .info-section .how-it-works .grid-section>div>img{
        width: 100%;
    }

    .info-section .how-it-works .grid-section{
        top: 15%;
    }

    .info-section .how-it-works .grid-section .red-point{
        height: 15px;
    }

    .prize-card-bg{
        width: 85%;
    }

    .choose-prize .arrow-icon{
        width: 55%;
    }

    .prize-name{
        font-size: 9px;
        font-weight: 700;
    }

    .info-button img{
        width: 12px;
    }

    .card-coin-row span {
        font-size: 12px;
    }

    .play-now-bg{
        width: 100%;
    }

    .choose-prize .content-section{
        padding: 5% 20% 5% 8%;
    }

    .info-button img{
        width: 12px;
    }

    .card-coin-row img{
        width: 20%;
    }

    .card-coin-row span{
        font-size: 12px;
        font-weight: 700;
    }

    .play-now-content div:first-child{
        font-size: 9px;
        font-weight: 700;
        margin-left: 10%;
    }

    .play-now-content .card-prize-image{
        width: 50%;
    }

    .play-now-content div:last-child{
        font-size: 15px;
        margin-left: 8%;
    }

    .features .grid-section{
        width: 55%;
        margin-left: 22%;
    }

    .info-section .choose-prize{
        top: 85%;
    }

    .features .grid-section img{
        height: 20px;
    }

    .back-btn{
        width: 5%;
    }

    .prize-title-image{
        width: 36%;
    }
}

@media (max-width: 700px) {
    .mobile{
        .info-section .how-it-works .grid-section>div>img {
            width: 90%;
        }

        .prize-frame-image{
            height: 90%;
        }

        .info-section .choose-prize{
            top: 78%;
        }
    }
}

@media (orientation: portrait) and (max-height: 736px) {
    .mobile{
        .inner-section{
            position: unset;
        }
        .prizes-root {
            background: url($assetRoot + "/prize/mobile/MB_bg.png") center no-repeat;
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            height: 100%;
            overflow: hidden;
        }

        .prize-frame-image{
            height: 100%;
        }

        .prize-section {
            top: 35%;
            width: 100%;
            height: 58%;
            transform: scaleY(.85);
            left: unset;
        }

        .live-claw-title{
            position: absolute;
            top: 8%;
            width: 44%;
            left: 28%;
        }

        .info-section {
            .how-it-works{
                z-index: 2;
                .header-section{
                    font-size: clamp(12px, 3.6vw, 44px);
                    top: 1%;
                }

                .grid-section{
                    top: 10%;
                    position: absolute;

                    .red-point {
                        height: unset;

                        img {
                            width: 15px;
                        }

                        span:first-of-type{
                            left: 8px;
                            font-size: clamp(10px, 1.5vw, 15px);
                        }

                        span:last-of-type {
                            font-size: clamp(8px, 1.5vw, 15px);
                            line-height: 0.95;
                        }
                    }
                }
            }

            .choose-prize {
                top: 41%;
                padding: 0 1vw;
                position: absolute;
                z-index: 2;

                .header-section {
                    font-size: clamp(12px, 3.6vw, 44px);
                }

                .grid-section {
                    gap: 1.6vw;
                }
            }
        }

        .play-now-content {
            font-size: 9px;
        }

        .info-button img {
            width: 16px;
        }

        .card-coin-row img{
            width: 20%;
        }

        .play-now-content div:last-child{
            margin-left: 5%;
            font-size: 20px;
        }
        .play-now-content .card-prize-image{
            width: 45%;
        }

        .play-now-content img{
            width: 20%;
        }

        .prize-name {
            font-size: clamp(12px, 3vw, 18px);
        }

        .features {
            padding: 1%;
            top: 87%;
        }

        .features .header-section {
            font-size: clamp(12px, 3.6vw, 44px);
        }

        .features .grid-section {
            gap: 1.4vw;
            width: unset;
            margin-left: unset;
        }

        .features .grid-section img {
            width: 28px;
            height: 28px;
        }

        .features .grid-section>div>div{
            font-size: clamp(11px, 2vw, 24px);
        }

        .choose-prize .header-section {
            margin-top: 5px;
            display: grid;
            grid-template-columns: 26px 1fr 26px;
            align-items: center;
            width: calc(100% - 8px);
            line-height: 1;
            text-transform: uppercase;
            font-family: "Bowlby One SC", sans-serif;
            color: #ffffff;
            font-size: clamp(12px, 3.6vw, 44px);
            -webkit-text-stroke: 6px #183cd0;
            paint-order: stroke fill;
        }

        .prize-card-bg {
            width: 100%;
            display: block;
        }

        .play-now-button {
            position: relative;
            padding: 0;
            border: 0;
            background: transparent;
            line-height: 0;
        }

        .card-coin-row span{
            scale: 0.8;
        }

        #products-page .page-footer{
            z-index: 3;
        }

        .prize-title-image{
            width: 100%;
        }

        .popup-box {
            width: 92%;
        }

        .close-btn {
            height: calc(10vw);
            right: calc(3vw);
            top: calc(-20vw);
        }

        .popup-subtitle{
            margin-top: calc(2vw);
            margin-bottom: calc(1vw);
        }

        .go-btn .btn-bg {
            width: calc(35vw);
            display: block;
        }

        .ic-coins{
            position: absolute;
            top: 2%;
            left: 0;
            width: 100%;

            img{
                width: 16px;
                height: 16px;
            }

            span{
                font-size: clamp(16px, 2vw, 55px);
            }
        }

        .ic-coins-popup{
            left: 0;
            width: 100%;

            img{
                width: 25px;
                height: 25px;
            }

            span{
                font-size: clamp(25px, 2vw, 55px);
            }
        }

        .back-btn{
            width: 10%;
            position: unset;
        }

        .info-section .how-it-works .grid-section>div>img{
            width: 100%;
        }

        .choose-prize .arrow-icon{
            width: 100%;
        }

        .choose-prize .content-section{
            padding: 8% 9% 10%;
        }

        .card-coin-row span{
            font-size: 20px;
        }
    }
}

@media (orientation: portrait) and (min-height: 737px) and (max-height: 1000px){
    .mobile{
        .inner-section{
            position: unset;
        }

        .prizes-root {
            background: url($assetRoot + "/prize/mobile/MB_bg.png") center no-repeat;
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            height: 100%;
            overflow: hidden;
        }

        .live-claw-title{
            position: absolute;
            top: 8%;
            width: 47%;
            left: 28%;
        }

        .prize-section {
            top: 38%;
            width: 100%;
            height: 55%;
            left: unset;
        }

        .prize-title-image{
            width: 100%;
        }

        .info-section {
            .prize-frame-image{
                height: 43vh;
            }

            .how-it-works{
                z-index: 2;
                .header-section{
                    font-size: clamp(12px, 3.6vw, 44px);
                    top: 1%;
                }

                .grid-section{
                    top: 8%;
                    position: absolute;
                    height: 13%;

                    .red-point {
                        margin-top: 10%;
                        height: 15px;

                        img {
                            width: 15px;
                        }

                        span:first-of-type{
                            left: 8px;
                            font-size: clamp(10px, 1.5vw, 15px);
                        }

                        span:last-of-type {
                            font-size: clamp(8px, 2.5vw, 15px);
                            line-height: 0.95;
                            vertical-align: middle;
                        }
                    }
                }
            }

            .choose-prize {
                top: 38%;
                padding: 0 1vw;
                position: absolute;
                z-index: 2;
                height: 23%;

                .header-section {
                    font-size: clamp(12px, 3.6vw, 44px);
                    height: 30%;
                    margin-top: 0px;
                    margin-bottom: 8px;
                }

                .grid-section {
                    gap: 1.6vw;
                }
            }
        }

        .play-now-content {
            font-size: 9px;
        }

        .info-button img {
            width: 16px;
        }

        .card-coin-row img {
            width: 20%;
        }

        .play-now-content div:last-child{
            margin-left: 5%;
            font-size: 20px;
        }
        .play-now-content .card-prize-image{
            width: 45%;
        }

        .play-now-content img{
            width: 20%;
        }

        .prize-name {
            font-size: clamp(12px, 3vw, 18px);
        }

        .features {
            padding: 1%;
        }

        .features .header-section {
            font-size: clamp(12px, 3.6vw, 44px);
            height: 2.5vh;
        }

        .features .grid-section {
            gap: 1.4vw;
            width: unset;
            margin-left: unset;
        }

        .features .grid-section img {
            width: 50%;
        }

        .features .grid-section>div>div{
            font-size: clamp(11px, 2.5vw, 24px);
        }

        .choose-prize .header-section {
            margin-top: 5px;
            display: grid;
            grid-template-columns: 26px 1fr 26px;
            align-items: center;
            width: calc(100% - 8px);
            line-height: 1;
            text-transform: uppercase;
            font-family: "Bowlby One SC", sans-serif;
            color: #ffffff;
            font-size: clamp(12px, 3.6vw, 44px);
            -webkit-text-stroke: 6px #183cd0;
            paint-order: stroke fill;
        }

        .prize-card-bg {
            width: 100%;
            display: block;
        }

        .play-now-button {
            position: relative;
            padding: 0;
            border: 0;
            background: transparent;
            line-height: 0;
        }

        .card-coin-row span{
            scale: 0.8;
        }

        #products-page .page-footer{
            z-index: 3;
        }

        .popup-image-box{
            height: clamp(210px, 25vw, 600px);
        }

        .popup-title{
            font-size: clamp(25px, 4vw, 72px)
        }

        .popup-subtitle{
            font-size: clamp(18px, 3vw, 60px)
        }

        .go-btn .btn-bg{
            width: 150px;
        }

        .ic-coins{
            position: absolute;
            top: 2%;
            left: 0;
            width: 100%;

            img{
                width: 20px;
                height: 20px;
            }

            span{
                font-size: clamp(20px, 2vw, 55px);
            }
        }

        .ic-coins-popup{
            left: 0;
            width: 100%;

            img{
                width: 25px;
                height: 25px;
            }

            span{
                font-size: clamp(25px, 2vw, 55px);
            }
        }

        .desc-img{
            height: clamp(105px, 15vw, 150px);
        }

        .back-btn{
            width: 10%;
            position: unset;
        }

        .info-section .how-it-works .grid-section>div>img{
            width: 100%;
        }

        .choose-prize .arrow-icon{
            width: 100%;
        }

        .play-now-content div:first-child{
            font-size: 12px;
            font-weight: 900;
            margin-left: 15%;
        }

        .choose-prize .content-section{
            padding: 8% 9% 10%;
        }

        .card-coin-row span{
            font-size: 20px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/prizes.vue